import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";

import { Authentication } from "@swegon/sds-core";

const AuthorizationRoute = ({ component, ...rest }) => {
    const { isAuthenticated, checkProdAuthority } = useContext(Authentication.AuthContext);
    return (
        <Route
            {...rest}
            render={props => {
                if (isAuthenticated()) {
                    return component();
                }

                checkProdAuthority(props.location);

                return (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: props.location }
                        }}
                    />
                );
            }}
        />
    );
};

export default AuthorizationRoute;
